module.exports = __webpack_public_path__ + "static/img/背景.ba3a273d.jpg";